<template>
  <v-container
    fluid
    tag="section"
    class="settings-aval"
  >
    <v-row class="h-100">
      <v-progress-circular
        v-if="isLoading"
        size="40"
        indeterminate
      />
      <v-col
        v-if="hasCompanyBankAccountSettings"
        class="col-sm-12 d-flex mt-3 flex-wrap companies-wrapper"
      >
        <div class="tables-block">
          <v-col
            cols="12"
            sm="12"
            class="pt-0 pb-2 pl-mid-0 block-company"
          >
            <v-card class="v-card-table">
              <v-card-text class="pa-0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="bill-name">
                          Key-Alias
                        </th>
                        <th class="currency">
                          Key-password
                        </th>
                        <th class="receipt">
                          Действия
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(setting, index) in settings"
                        :key="index"
                      >
                        <td class="bill">
                          {{ setting.login }}
                        </td>
                        <td class="bill-name">
                          {{ setting.password }}
                        </td>
                        <td class="email">
                          <v-icon
                            small
                            @click="deleteCompanyBankAccountSetting(setting)"
                          >
                            delete
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AvalBankSettingTable',
    props: {
      settings: {
        type: Array,
        required: true,
      },
      isLoading: {
        type: Boolean,
        required: true,
      },
      hasCompanyBankAccountSettings: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      deleteCompanyBankAccountSetting (setting) {
        setting.bank_alias = 'aval'
        this.$emit('delete', Object.assign(setting))
      },
    },
  }
</script>

<style scoped>

</style>
